import React, {useState} from "react";
import styles from "./styles.css";
import dollar from "./images/dollar.svg";
import mobile from "./images/mobile.png";
import money from "./images/money.svg";
import search from "./images/search.svg";
import user from "./images/user.svg";
import tradein from "./images/tradein.svg";

const HowItWorksTradeIn = () => {
    const Tabs = ["Sell outright", "Trade-in"];
    const [activeTab, setActiveTab] = useState(Tabs[0]);
    return (
        <div styleName={"styles.outer"}>
            <h2 styleName={"styles.header"}>How it works</h2>
            <ul styleName={"styles.atfTab"} >
                {Tabs.map((item, index) =>
                    (<li styleName={activeTab === item ? "styles.activeTab" : ""} key={index} onClick={() => setActiveTab(item)}>
                        {item}
                    </li>)
                )}
            </ul>
            {activeTab === "Trade-in"  && <div className="row">
                <div className="col-4" styleName={"styles.section"}>
                    <img src={mobile} />
                    <h2 styleName={"styles.heading"}>Get free online valuation</h2>
                    <p>Add your car details to<br/> get an instant offer<br/> valid for 7 days</p>
                </div>

                <div className="col-4" styleName={"styles.section"}>
                    <img src={money} />
                    <h2 styleName={"styles.heading"}>Money saved</h2>
                    <p> Get your trade-in <br/>valuation as price off on<br/>your new car</p>
                </div>

                <div className="col-4" styleName={"styles.section"}>
                    <img src={tradein} />
                    <h2 styleName={"styles.heading"}>Seamless process</h2>
                    <p>We’ll pick up your trade-in <br/>car at the time of delivery<br/> of your new car</p>
                </div>
            </div>
            }
            { activeTab === "Sell outright"  &&
                <div className="row">
                    <div className="col-4" styleName={"styles.section"}>
                        <img src={search} />
                        <h2 styleName={"styles.heading"}>Get free online valuation</h2>
                        <p>Add your car details to<br/>get an instant offer <br/> valid for 7 days</p>
                    </div>
                    <div className="col-4" styleName={"styles.section"}>
                        <img src={user} />
                        <h2 styleName={"styles.heading"}>Book inspection</h2>
                        <p>Via video call with<br/>an inspector</p>
                    </div>
                    <div className="col-4" styleName={"styles.section"}>
                        <img src={dollar} />
                        <h2 styleName={"styles.heading"}>Get paid</h2>
                        <p>Provide your payment details and we’ll transfer funds when we pick-up the car</p>
                    </div>
                </div>
            }
        </div>
    );
};

export default HowItWorksTradeIn;
